import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
    return (
        <div className="min-h-screen bg-white">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 md:py-24">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-primary mb-8"
                    data-testid="privacy-back-link"
                >
                    <ArrowLeft className="w-4 h-4" /> Back
                </Link>
                <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-2">
                    Privacy Policy
                </h1>
                <p className="text-sm text-slate-500 mb-10">
                    Placeholder page — full privacy policy coming soon.
                </p>
                <div className="prose prose-slate max-w-none text-slate-700 leading-relaxed">
                    <p>
                        GrowthX AI Partners LLP collects minimal information
                        necessary to deliver the GTM audit and weekly Monday
                        briefs. We collect: information you submit via the
                        booking form (name, email, company, vertical, ad spend)
                        and the marketing parameters that brought you to this
                        page (UTM tags, referrer, click IDs).
                    </p>
                    <p>
                        We do not run Google Analytics or Facebook Pixel on this
                        page. Calendly is used for booking and operates under
                        its own privacy policy. Analytics, if enabled, are
                        privacy-friendly and aggregated only.
                    </p>
                    <p>
                        For any data request, deletion request, or question,
                        write to info@growthx.digital.
                    </p>
                </div>
            </div>
        </div>
    );
}
